import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Request } from "../utils/Request";
import { TokenValues } from "../values/strings";
import { useLanguageProvider } from "./LanguageProvider";
import { useUserProvider } from "./UserProvider";

const CoreRequestContext = React.createContext();

export const CoreRequestProvider = ({ children }) => {
  const { t, i18n } = useTranslation();
  const lang = useLanguageProvider();
  const userProvider = useUserProvider();
  const request = new Request({
    "Accept-Language": "fa-ir,fa",
    "RX-ACCESS-TOKEN": TokenValues.coreAccess,
    "RX-USER-TOKEN": userProvider.accessToken,
    "RX-USER-META": "",
  });

  // React.useEffect(() => {
  //   request.instance.defaults.headers["Accept-Language"] =
  //     lang.getAcceptLanguage();
  //   console.log(request.instance.defaults.headers["Accept-Language"]);
  // }, []);

  return (
    <CoreRequestContext.Provider value={request}>
      {children}
    </CoreRequestContext.Provider>
  );
};

export const useCoreRequestProvider = () => {
  return useContext(CoreRequestContext);
};
